import Immutable from 'immutable';

import {
	StaticLookup,
	RestLookup,
	initializeLookupStore,
	webapi,
	REPORTED_EXCEPTION
} from 'ps-gui';
import { getPhrase } from './phrases';

let lookupMap = {};

export const EMPTY_LOOKUP = StaticLookup(Immutable.List([]));

export function getLookup(name) {
	return lookupMap[name] || EMPTY_LOOKUP;
}

export function setLookup(name, lookup) {
	lookupMap[name] = lookup;
}

export function setLookupFromItems(name, items) {
	lookupMap[name] = StaticLookup(Immutable.fromJS(items));
}

export function lookupExists(name) {
	return !!lookupMap[name];
}

initializeLookupStore(getLookup);

const restLookups = [
	'user',
	'partyIdName',
	'nativeUser'
];

const comboRestLookups = {
};

function fromKeyList(name, keys, keyAsText) {
	return StaticLookup(Immutable.fromJS(
		keys.map(key => {
			return {
				key,
				text: keyAsText ? getPhrase(key) : null,
				cells: [getPhrase(name + '.' + key)]
			};
		})
	));
}

async function loadStaticLookups() {
	let res = await webapi.execute('/api/proc/api_lookup/getStaticLookups');
	if (res === REPORTED_EXCEPTION) {
		return;
	}
	res.forEach(lu => {
		lookupMap[lu.name] = StaticLookup(Immutable.fromJS(lu.items));
	});
	console.log('lookups', res);
}

function initializeRestLookups() {
	restLookups.forEach(rl => {
		let searchUrl;
		let processFilter;
		if (typeof rl === 'string') {
			searchUrl = '/api/proc/api_lookup/' + rl + 'Search';
			//processFilter = sqlFullText[rl] ? getSqlFulltextFilter : null;
			processFilter = null;
		} else {
			searchUrl = rl.searchUrl;
			processFilter = rl.processFilter;
			rl = rl.name;
		}
		lookupMap[rl] = RestLookup('/api/proc/api_lookup/' + rl + 'Text', searchUrl, processFilter, null, comboRestLookups[rl]);
	});

}

export async function initializeLookups() {
	console.log('initializeLookups');
	lookupMap['distType'] = fromKeyList('distType', ['IP', 'NP'], true);
	lookupMap['audioVideo'] = fromKeyList('audioVideo', ['A', 'V']);
	lookupMap['ynBoolean'] = fromKeyList('ynBoolean', ['Y', 'N']);
	await loadStaticLookups();
	initializeRestLookups();
}
